import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    count: 0
  },
  getters: {
    getCount: state => {
      return state.count.toString() + '元'
    }
  },
  mutations: {
    increment (state) {
      state.count++
      console.log(state.count)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js